import { IDCardFileRequest } from './../models/staff/id-card-file-request.model';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GlobalService } from '../providers/global.service';
import {
  FileFullResponse,
  FileResponse,
} from '../providers/request/file-response.model';
import { IDCardFileResponse } from '../models/staff/id-card-file-response.model';
import { WeatherInfo } from '../models/weather/weather-info.model';
import { Observable } from 'rxjs';
import { EsSearchRequest } from '../models/archive/es-search-request.model';
import { EsSearchResponse } from '../models/archive/es-search-response.model';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  static PATH = '/common';
  constructor(
    public httpClient: HttpClient,
    public globalService: GlobalService,
  ) {}

  uploadFile(file: File, convertToPdf?: boolean) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    if (convertToPdf) {
      formData.append('convertToPdf', 'true');
    }
    return this.httpClient.request<FileFullResponse>(
      new HttpRequest(
        'POST',
        `${
          this.globalService.debugUrl
            ? this.globalService.debugUrl
            : environment.host
        }/common/file/upload`,
        formData,
        {
          reportProgress: true,
        },
      ),
    );
  }

  uploadFileWithoutProgress(file: File, convertToPdf?: boolean) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    if (convertToPdf) {
      formData.append('convertToPdf', 'true');
    }
    return this.httpClient.post<FileResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }/common/file/upload`,
      formData,
    );
  }

  loadLargeFile(url: string) {
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  ocrIdCard(iDCardFileRequest: IDCardFileRequest) {
    return this.httpClient.post<IDCardFileResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }/common/ocr/idcard/uploadUrl`,
      iDCardFileRequest,
    );
  }

  getWeather(date: string) {
    return this.httpClient.post<WeatherInfo>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }/common/weather/get`,
      {
        locationId: '330109',
        date,
      },
    );
  }

  download(fileId: string, fileName: string): Observable<Blob> {
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }/common/file/downloadFile`,
      { fileId, fileName },
      { responseType: 'blob' },
    );
  }

  searchArchive(req: EsSearchRequest) {
    return this.httpClient.post<EsSearchResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }/archive/search/v1`,
      req,
    );
  }

  reindex(name: string) {
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }/common/search/reindex/${name}`,
      {},
    );
  }
}
